export default __webpack_public_path__ + "static/media/cigarette1.1674b400.png";